import React from 'react'

const ConfirmDialog = ({message, onOkClick, onCancelClick}) => {
    return (
      <div id="confirm-dialog" className="confirm-modal">
          <div className="confirm-modal-content">
              <p id="confirm-message">{message}</p>
              <div className="confirm-modal-buttons">
                  <button className="confirm-modal-button confirm-yes" onClick={onOkClick} >はい</button>
                  <button className="confirm-modal-button confirm-no" onClick={onCancelClick}>いいえ</button>
              </div>
          </div>
      </div>
    )
  }
  
export default ConfirmDialog